var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollections(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00694 0.800003C4.29077 0.800003 2.94538 1.13984 2.043 2.04222C1.14062 2.9446 0.800781 4.28999 0.800781 6.00616V9.99385C0.800781 11.71 1.14062 13.0554 2.043 13.9578C2.94538 14.8602 4.29077 15.2 6.00694 15.2H9.99463C11.7108 15.2 13.0562 14.8602 13.9586 13.9578C14.8609 13.0554 15.2008 11.71 15.2008 9.99385V6.00616C15.2008 4.28999 14.8609 2.9446 13.9586 2.04222C13.0562 1.13984 11.7108 0.800003 9.99463 0.800003H6.00694ZM1.90847 6.00616C1.90847 4.39924 2.23325 3.41849 2.82626 2.82548C3.41926 2.23247 4.40002 1.9077 6.00694 1.9077H7.40078V7.4H1.90847V6.00616ZM1.90847 8.6V9.99385C1.90847 11.6008 2.23325 12.5815 2.82626 13.1745C3.41926 13.7675 4.40002 14.0923 6.00694 14.0923H7.40078V8.6H1.90847ZM8.60078 8.6V14.0923H9.99463C11.6015 14.0923 12.5823 13.7675 13.1753 13.1745C13.7683 12.5815 14.0931 11.6008 14.0931 9.99385V8.6H8.60078ZM14.0931 7.4V6.00616C14.0931 4.39924 13.7683 3.41849 13.1753 2.82548C12.5823 2.23247 11.6015 1.9077 9.99463 1.9077H8.60078V7.4H14.0931Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollections);
export default __webpack_public_path__ + "static/media/collections.b1fb3911681c1fd8c4dd27be2e20f624.svg";
export { ForwardRef as ReactComponent };